import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { NgxCurrencyDirective } from 'ngx-currency';
import { MotorFiscalLookupService } from '../../../../../shared/services/apis/motor-fiscal/motor-fiscal-lookup.service';
import { UtilService } from '../../../../../shared/services/util.service';

interface CstOption {
  codigo: string;
  descricao: string;
}

@Component({
  selector: 'app-servico-tomado-impostos-creditados',
  standalone: true,
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatIconModule, NgxCurrencyDirective],
  templateUrl: './servico-tomado-impostos-creditados.component.html',
})
export class ServicoTomadoImpostosCreditadosComponent implements OnInit {
  @Input({ required: true }) form!: FormGroup;
  @Input() dynamicCurrencyMask: any;
  @Input() percentageMask: any;

  public cstsPis: CstOption[] = [];
  public cstsCofins: CstOption[] = [];

  constructor(private motorFiscalLookupService: MotorFiscalLookupService) { }

  ngOnInit(): void {
    this.motorFiscalLookupService.getTributosDominios().subscribe({
      next: (res) => {
        if (!res.isError) {
          this.cstsPis = res.cstsPis || [];
          this.cstsCofins = res.cstsCofins || [];
        }
      }
    });
  }

  /**
   * Recalcula o valor creditado (base × alíquota / 100) de um grupo ('pisCreditado' ou
   * 'cofinsCreditado'). Arredondamento ABNT (NBR 5891), como no resto do sistema.
   */
  public recalcular(prefixo: 'pisCreditado' | 'cofinsCreditado'): void {
    const base = Number(this.form.get(`${prefixo}Base`)?.value) || 0;
    const aliquota = Number(this.form.get(`${prefixo}Aliquota`)?.value) || 0;
    const valor = UtilService.arredondarAbnt(base * aliquota / 100, 2);
    this.form.get(`${prefixo}Valor`)?.setValue(valor || null, { emitEvent: false });
  }
}
